export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const SIGN_UP = "SIGN_UP";
export const SET_CURRENT_USER = 'SET_CURRENT_USER';